//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/NXObject.js";
let d=[[],[[[],"GetOutputGeometryLayer",{R_:{outputGeomLayer:''}},0,0],[["outputGeomLayer"],"SetOutputGeometryLayer",{},1,0],[[],"GetConstructionLayer",{R_:{constructionLayer:''}},0,0],[["constructionLayer"],"SetConstructionLayer",{},1,0],[[],"GetFixTimestamp",{R_:{fixTimestamp:''}},0,0],[["fixTimestamp"],"SetFixTimestamp",{},1,0],[[],"GetGroupIdSeedValue",{R_:{groupIdSeedValue:''}},0,0],[["groupIdSeedValue"],"SetGroupIdSeedValue",{},1,0]],[]];
SPLM.Join.JoinPreferences = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.JoinPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;